export { default as MenuSolidIcon } from './MenuSolidIcon';
